import { render } from "./GameCard1.vue?vue&type=template&id=6d343714&scoped=true"
import script from "./GameCard1.vue?vue&type=script&lang=js"
export * from "./GameCard1.vue?vue&type=script&lang=js"

import "./GameCard1.vue?vue&type=style&index=0&id=6d343714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d343714"]])

export default __exports__